import type { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
// import { Currency } from "src/components/transactionsRework/TransactionsList";
import IconMapping from "../../utils/iconMapping";
import { Currency } from "./types";

export const Styles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginLeft: "10px",
      marginBottom: "6px",
      position: "relative",
    },
    topItem: {
      zIndex: 9,
    },
    bottomItem: {
      // width: "100%",
      // height: "100%",
      position: "absolute",
      top: 12,
      left: 16,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "32px",
      height: "32px",
      backgroundColor: "#e5e7e8",
    },
    imageContainer: {
      display: "flex",
      justifyContent: "flex-end",
    },
    image: {
      width: "28px",
      height: "28px",
      borderRadius: "50%",
    },
  }),
);

interface TransactionIconsMappingProps {
  type: string;
  quote: Currency;
  base: Currency;
}

export default function TransactionIconsMapping(props: TransactionIconsMappingProps) {
  const { type, quote, base } = props;
  const classes = Styles();

  if (type === "Crypto Withdrawal") {
    return (
      <div className={classes.imageContainer}>
        {base.type === "Crypto" && <img className={classes.image} src={base.logoUrl} alt="..." />}
      </div>
    );
  }

  if (type === "Crypto Deposit") {
    return (
      <div className={classes.imageContainer}>
        {base.type === "Crypto" && <img className={classes.image} src={base.logoUrl} alt="..." />}
      </div>
    );
  }

  if (type === "Fiat Withdrawal") {
    return (
      <div className={classes.imageContainer}>
        {quote.type === "Fiat" && IconMapping(quote.code.toLowerCase(), 28)}
      </div>
    );
  }
  //   if Fiat Deposit display single item
  if (type === "Fiat Deposit") {
    return (
      <div className={classes.imageContainer}>
        {quote.type === "Fiat" && IconMapping(quote.code.toLowerCase(), 28)}
        {quote.type === "Crypto" && <img className={classes.image} src={quote.logoUrl} alt="..." />}
      </div>
    );
  }

  //   if trade or buy order add incoming symbols to template
  if (type === "Buy Order" || type === "Trade Order" || "Target Order") {
    return (
      <>
        <div className={classes.container}>
          <div className={classes.topItem}>
            {quote.type === "Fiat" && IconMapping(quote.code.toLowerCase(), 28)}
            {quote.type === "Crypto" && (
              <img className={classes.image} src={quote.logoUrl} alt="..." />
            )}
          </div>
          <div className={classes.bottomItem}>
            {base.type === "Fiat" && IconMapping(base.code.toLowerCase(), 16)}
            {base.type === "Crypto" && <img height="16px" src={base.logoUrl} alt="..." />}
          </div>
        </div>
      </>
    );
  }
  return <></>;
}
